import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { accountTree } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { AccountRow } from "../features/acct/AccountRow";
import { AccountForm } from "../features/acct/AccountForm";
import { flattenAccounts } from "../features/acct/flattenAccounts";
import { useCachedResource } from "../hooks/useCachedResource";
import { NeuButton, NeuCard } from "../components/neu/Neu";

export default function AcctAccountsPage() {
  const { t } = useTranslation();
  const { data: tree, reload: load } = useCachedResource("acct-accounts", () => accountTree().catch(() => []));
  const [collapsed, setCollapsed] = useState([]);
  const [editing, setEditing] = useState(null);

  const toggle = (code) =>
    setCollapsed((prev) => (prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]));

  const rows = flattenAccounts(tree || [], collapsed);
  const done = () => {
    setEditing(null);
    load();
  };

  return (
    <AcctShell
      titleKey="accounts"
      actions={
        <NeuButton variant="primary" className="flex items-center gap-2" data-testid="account-add"
          onClick={() => setEditing({})}>
          <Plus className="h-4 w-4" /> {t("acct.addAccount")}
        </NeuButton>
      }
    >
      {editing ? <AccountForm initial={editing.code ? editing : null} onDone={done} onCancel={() => setEditing(null)} /> : null}
      <NeuCard className="p-4" data-testid="account-tree">
        {rows.map((row) => (
          <AccountRow key={row.code} row={row} open={!collapsed.includes(row.code)} onToggle={toggle}
            onEdit={() => setEditing(row)} />
        ))}
      </NeuCard>
    </AcctShell>
  );
}
